export default "__VITE_ASSET__CqroDz1J__"